import React , {Component} from "react"
import Asset4 from "../../assets/Client/03.png";
import {Collapse} from "reactstrap";
import './styles.css'
import ClassNames from "classnames"
import {Helmet} from "react-helmet";
import FavIcon from "../../assets/FavIcons/03.ico";

const Question =({index ,  answer , question , clickEvent , isOpen})=>{
    let iconCollapseClasses=ClassNames({
        'fa' : true,
        'collapseBtn' : true,
        'fa-chevron-down' : !isOpen,
        'fa-chevron-up' : isOpen
    })
    return(
        <React.Fragment>
            <div> {question}</div>
            <Collapse
                isOpen={isOpen}
            >
                <div className="questionAnswer"> {answer}</div>
            </Collapse>
            <div style={{display : 'flex' , flexDirection : 'row-reverse'}}>
                <i  onClick={()=>clickEvent(index)} className={iconCollapseClasses}/>
            </div>

        </React.Fragment>

    )
}


export class FAQ extends Component{
    constructor(props) {
        super(props);
        this.state={
            isClients : true,
            questions : {
                clients : [
                    {
                        question : 'Comment faire pour demander un Chauffeur ADSIL ?',
                        answer : 'Il vous suffit d’installer l’application, de vous inscrire en mettant vos informations personnelles et ensuite entrez la date et l’heure du voyage, votre wilaya et point de départ et votre destination, ainsi le nombre de Places à réserver puis cliquez sur ‘Confirmer le Voyage’',
                        isOpen :false,
                        index :0
                    } ,
                    {
                        question : 'Est-ce possible d’avoir une facture pour ma course afin de justifier mes déplacements ?',
                        answer : 'Oui, vous pouvez demander une facture à la fin de la course via l’application, tout en mentionnant votre adresse Email.',
                        isOpen : false,
                        index:1
                    } ,
                    {
                        question : 'Comment utiliser l’application ?',
                        answer : 'Vous pouvez consulter la vidéo explicative sur réseaux Sociaux. Vous trouverez tous les détails nécessaires concernant l’utilisation de l’application.',
                        isOpen : false,
                        index:2
                    } ,
                    {
                        question : 'Est-ce que votre service est disponible tous les jours et à quel moment je peux réserver mon voyage ?',
                        answer : 'Oui, nous avons des voyages programmés pendant toutes la journée vers plusieurs lignes/Wilaya Vous pouvez faire une demande à n’importe quel moment de la journée, mais le plutôt est le mieux afin d’assurer la disponibilité',
                        isOpen : false,
                        index:3

                    } ,
                    {
                        question : 'Comment faire pour obtenir un code promo ?',
                        answer : 'Les codes promo ou Réductions seront envoyés directement à travers les notifications de l’application.',
                        isOpen : false,
                        index:4

                    }

                ],
                partenaires : [
                    // {
                    //     question : 'COMMENT FAIRE POUR RECEVOIR LE PAIEMENT ? 10',
                    //     answer : 'attendez votre paiement dans les 24h, soit par CCP soit par FLEXY, vous pouvez sélectionner la méthode via l\'application mobile',
                    //     isOpen : false,
                    //     index:0
                    //
                    // } ,
                    // {
                    //     question : 'COMMENT FAIRE POUR RECEVOIR LE PAIEMENT ? 11',
                    //     answer : 'attendez votre paiement dans les 24h, soit par CCP soit par FLEXY, vous pouvez sélectionner la méthode via l\'application mobile',
                    //     isOpen : false,
                    //     index:1
                    // } ,
                    // {
                    //     question : 'COMMENT FAIRE POUR RECEVOIR LE PAIEMENT ? 12',
                    //     answer : 'attendez votre paiement dans les 24h, soit par CCP soit par FLEXY, vous pouvez sélectionner la méthode via l\'application mobile',
                    //     isOpen : false,
                    //     index:2
                    // } ,
                    // {
                    //     question : 'COMMENT FAIRE POUR RECEVOIR LE PAIEMENT ? 13',
                    //     answer : 'attendez votre paiement dans les 24h, soit par CCP soit par FLEXY, vous pouvez sélectionner la méthode via l\'application mobile',
                    //     isOpen : false,
                    //     index:3
                    // } ,
                    // {
                    //     question : 'COMMENT FAIRE POUR RECEVOIR LE PAIEMENT ? 14',
                    //     answer : 'attendez votre paiement dans les 24h, soit par CCP soit par FLEXY, vous pouvez sélectionner la méthode via l\'application mobile',
                    //     isOpen : false,
                    //     index:4
                    //
                    // } ,
                    // {
                    //     question : 'COMMENT FAIRE POUR RECEVOIR LE PAIEMENT ? 15',
                    //     answer : 'attendez votre paiement dans les 24h, soit par CCP soit par FLEXY, vous pouvez sélectionner la méthode via l\'application mobile',
                    //     isOpen : false,
                    //     index:5
                    // }
                ]
            }

        }
    }
    toggleCollapse=(index)=>{
        console.log(index);
        console.log(this.state.isClients);
        let questions = {...this.state.questions}
        if(this.state.isClients){
            let clients = [...questions.clients]
            clients[index].isOpen= !clients[index].isOpen;
            questions.clients=clients;
            console.log('AFTER :');
            console.log(questions);
            this.setState({...this.state , questions : questions});
        }else{
            let partenaires = [...questions.partenaires]
            partenaires[index].isOpen= !partenaires[index].isOpen;
            questions.partenaires=partenaires;
            console.log('AFTER :');
            console.log(questions);
            this.setState({...this.state , questions : questions});
        }

    }
    toggleClientPartenaireButton =(event)=>{
        if(!event.target.classList.contains('faqButtonsActive'))
            this.setState({...this.state , isClients : !this.state.isClients})
    }
    render(){
        const Clients = this.state.questions.clients.map((question , index )=>{
            console.log("KEY = ", index)
            return (
                <div id={"Q"+index} key={index}  className="p-3 question">
                    <Question isOpen={question.isOpen}  clickEvent={this.toggleCollapse} index={question.index} question={question.question} answer={question.answer} />
                </div>

            )
        });
        const Partenaires = this.state.questions.partenaires.map((question , index )=>{
            console.log("KEY = ", (index+1)*100)
            return (
                <div id={"Q"+index} key={index}  className="p-3 question">
                    <Question isOpen={question.isOpen} clickEvent={this.toggleCollapse} index={question.index} question={question.question} answer={question.answer} />
                </div>
            )
        });
        const ClientsButtonClasses = ClassNames({
            'pt-2' : true ,
            'pb-2' : true ,
            'pr-4' : true ,
            'pl-4' : true ,
            'faqButtons' : true ,
            'faqButtonsActive' : this.state.isClients
        });
        const PartenairesButtonClasses=ClassNames({
            'pt-2' : true ,
            'pb-2' : true ,
            'pr-4' : true ,
            'pl-4' : true ,
            'faqButtons' : true,
            'faqButtonsActive' : !this.state.isClients
        });
        return(
            <React.Fragment>
                <Helmet>
                    <title> ADSIL FAQ</title>
                    <link rel="shortcut icon"  href={FavIcon} />
                </Helmet>
                <div className="col-12 text-black"  id="FAQSec1" style={{paddingTop : '2rem'}}>
                    <div className="d-flex justify-content-center mt-4 mb-4">
                        <img style={{height : '5rem'}} src={Asset4} alt=""/>
                    </div>
                    <div className="d-flex justify-content-center mb-4">
                        <h2 className="pt-1 d-inline" style={{textAlign : 'center' , borderBottom : "5px solid var(--primary-adsil-color)" , fontWeight : 'bold'}}> QUESTIONS FREQUEMMENT POSEES </h2>
                    </div>
                    <div className="d-flex faqButtonsContainer">
                        <div onClick={(event)=>this.toggleClientPartenaireButton(event)}  className={ClientsButtonClasses}>
                            CLIENTS
                        </div>
                        <div onClick={(event)=>this.toggleClientPartenaireButton(event)} className={PartenairesButtonClasses}>
                            PARTENAIRES
                        </div>
                    </div>
                    <div  className="offset-1 col-10 text-gray mb-5 mt-lg-3 mb-lg-5 " id="questions">
                        {this.state.isClients ? Clients : Partenaires }
                    </div>
                </div>
            </React.Fragment>

        )
    }
}